<template>
  <el-container v-if="loading" v-loading="loading" class="loading-container" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingBlock',
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
.loading-container {
  height: 10em;
  z-index: 300;
}

.dark {
  .loading-container {
    :deep(.el-loading-mask) {
      background-color: #161616;
    }
  }
}
</style>
